<div class="progress-style mb-7" *ngIf="tokensForShow">
  <div class="progress">
    <ng-container *ngIf="totalBalance$ | async as totalBalance">
      <ng-container *ngFor="let token of tokensForShow">
        <div
          [attr.id]="'progress-bar-bg-' + (token.ticker | lowercase)"
          class="progress-bar w-100"
          [ngClass]="'bg-' + (token.ticker | lowercase)"
          role="progressbar"
          [ngStyle]="token | coinProgressStyle: totalBalance"
          aria-valuenow="10"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </ng-container>
    </ng-container>
  </div>
  <div class="marquee ticker-wrap" cdTicker>
    <div class="progress-content ticker-marker">
      <ng-container *ngFor="let token of tokensForShow">
        <div class="media media-table media-table-lg">
          <div class="align-img">
            <img [src]="token.image" alt="">
          </div>
          <div class="media-body" *ngIf="currency$ | async as currency">
            <p>1 <strong>{{ token.ticker }}</strong> = {{ token.listing_price | currency: currency }} </p>
        </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
